import React from 'react';
import { AlertTriangleIcon, DollarSignIcon, ClockIcon, CreditCardIcon } from 'lucide-react';
export function TrustSection() {
  const stats = [{
    icon: AlertTriangleIcon,
    stat: '$3.4B',
    label: 'Lost to Fraud',
    description: 'Adults over 60 lost $3.4 billion to fraud in 2023 alone.'
  }, {
    icon: DollarSignIcon,
    stat: '$83,000+',
    label: 'Average Loss',
    description: 'The average loss per incident for victims over 60.'
  }, {
    icon: ClockIcon,
    stat: '3-5 hrs',
    label: 'Monthly Hidden Tax',
    description: 'Time the average "Family IT person" spends on unpaid tech support.'
  }, {
    icon: CreditCardIcon,
    stat: '$400-700',
    label: 'Wasted on tools families set up once and never finish configuring',
    description: 'What households pay in redundant security and cloud services.'
  }];
  return <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-406" data-mp="1u9ghklqpv7pu">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-407" data-mp="2pvbnru6afycj">
        <div className="text-center mb-16" data-id="element-408" data-mp="2kx0h1sbai3yj">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-6" data-id="element-409" data-mp="2kxa3x711fv00">
            The risks are real. So is the cost of doing nothing.
          </h2>
          <p className="text-base md:text-lg text-gray-500 leading-relaxed max-w-3xl mx-auto" data-id="element-410" data-mp="2bvam4ci78mw0">
            The people getting hurt aren't careless. They just never had anyone
            explain the risks in a way that made sense.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-411" data-mp="1x6wmsbjzrgk7">
          {stats.map((item, index) => <div key={index} className={`bg-[#f8f8f8] rounded-2xl p-6 border-2 border-gray-200 text-center flex flex-col ${index === 3 ? 'border-[#631bb7] border-opacity-30 bg-[#f0ebf8]' : ''}`} data-id="element-412" data-mp="1t6dukge6s8hh" data-mpi={index}>
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center mx-auto mb-4 border border-[#631bb7] border-opacity-10" data-id="element-413" data-mp="1j86o4rhix8tq">
                <item.icon className="w-6 h-6 text-[#631bb7]" data-id="element-414" data-mp="1ejx6s34bmukp" />
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-[#111111] mb-1" data-id="element-415" data-mp="zm4xhspdb2ey">
                {item.stat}
              </div>
              <div className={`text-sm font-bold uppercase tracking-wide mb-3 ${index === 3 ? 'text-[#631bb7]' : 'text-gray-500'}`} data-id="element-416" data-mp="14l7z13652qi6">
                {item.label}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mt-auto" data-id="element-417" data-mp="1x8lt8tigd7yl">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}